var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.field.instructions),expression:"field.instructions"}],attrs:{"for":_vm.field.id}},'small',_vm.attributes,false),[_vm._v("\n    "+_vm._s(_vm.field.instructions)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }